import Vue from 'vue'
import VueRouter from 'vue-router'
const PrivacyAgreement=()=>import('../views/privacyAgreement')
const UsersAgreement=()=>import('../views/usersAgreement')
const SvipServiceAgreement=()=>import('../views/svipServiceAgreement')
const SvipContinuSubscribAgreement=()=>import('../views/svipContinuSubscribAgreement')
const Home=()=>import('../views/Home')
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
      path: '/usersAgreement',
      name: 'UsersAgreement',
      component: UsersAgreement
    },
    {
      path: '/privacyAgreement',
      name: 'PrivacyAgreement',
      component: PrivacyAgreement
    },
    {
      path: '/svipServiceAgreement',
      name: 'svipServiceAgreement',
      component: SvipServiceAgreement
    },
    {
      path: '/svipContinuSubscribAgreement',
      name: 'svipContinuSubscribAgreement',
      component: SvipContinuSubscribAgreement
    }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
